import "./App.css";
import "./site/site.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Page from "./site/Page";
import { AuthProvider } from "./site/auth";
import AuthCallback from "./site/AuthCallback";
import Login from "./site/Login";
import Admin from "./site/Admin";

import * as Home from "./site/pages/Home";
import * as OurApproach from "./site/pages/OurApproach";
import * as WhatWeDo from "./site/pages/WhatWeDo";
import * as PeopleAndPartners from "./site/pages/PeopleAndPartners";
import * as Transparency from "./site/pages/Transparency";
import * as WorkWithUs from "./site/pages/WorkWithUs";
import * as Contact from "./site/pages/Contact";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return FIRST (session_id lives in the URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Page html={Home.html} title={Home.title} description={Home.description} />} />
      <Route path="/our-approach" element={<Page html={OurApproach.html} title={OurApproach.title} description={OurApproach.description} />} />
      <Route path="/what-we-do" element={<Page html={WhatWeDo.html} title={WhatWeDo.title} description={WhatWeDo.description} />} />
      <Route path="/people-and-partners" element={<Page html={PeopleAndPartners.html} title={PeopleAndPartners.title} description={PeopleAndPartners.description} />} />
      <Route path="/transparency" element={<Page html={Transparency.html} title={Transparency.title} description={Transparency.description} />} />
      <Route path="/work-with-us" element={<Page html={WorkWithUs.html} title={WorkWithUs.title} description={WorkWithUs.description} />} />
      <Route path="/contact" element={<Page html={Contact.html} title={Contact.title} description={Contact.description} />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Page html={Home.html} title={Home.title} description={Home.description} />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
